import React, { useState } from "react";

import Section from "@coninsa-s2/section";
import Container from "@coninsa-s2/container";
import Button from "@coninsa-s2/button";

type T_props = {
  list: Array<{ id: string; label: string; path: string; title: string }>;
  subTitle?: string;
};

export function FrequentSearch({ list, subTitle }: T_props) {
  const [showAll, setShowAll] = useState(false);
  const itemsToShow = showAll ? list : list?.slice(0, 20);

  const handleShowMoreToggle = () => {
    setShowAll(!showAll);
  };

  return (
    <Section ptop="small">
      <Container>
        <div>
          {subTitle && <h3 className="mb-6 font-semibold">{subTitle}</h3>}
          <div className="">
            <ul id="item-container" className="gap-4 grid lg:grid-cols-4 mb-6">
              {itemsToShow?.map((item) => (
                <li className="hover:text-co-teal">
                  <a href={item.path} title={item.title}>
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
            <div className="flex justify-center mx-auto">
              {list?.length > 5 && (
                <Button variant="ghost" onClick={handleShowMoreToggle}>
                  {showAll ? "Mostrar menos" : "Mostrar más"}
                </Button>
              )}
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
}
